import { useEffect, useRef, useState } from "react";
import { Alert, Button, Collapse, Stack, Typography } from "@mui/material";
import {
  isWebPushSupported,
  registerWebPushOnDevice,
} from "../notifications/webPushClient";
import { isMobileTeamViewport } from "../utils/teamNavigation";

const DISMISS_KEY = "xpro_voice_push_onboard_dismissed_v1";

/**
 * No mobile/PWA, pede permissão de notificação para acordar o app em ligações.
 */
export default function VoicePushOnboardingBanner({ enabled = true }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const ranRef = useRef(false);

  useEffect(() => {
    if (!enabled || ranRef.current) return;
    ranRef.current = true;
    try {
      if (localStorage.getItem(DISMISS_KEY) === "1") return;
    } catch (_) {
      /* ignore */
    }
    if (!isWebPushSupported()) return;
    if (!isMobileTeamViewport()) return;
    if (typeof Notification === "undefined") return;
    if (Notification.permission === "granted") return;
    if (Notification.permission === "denied") return;
    setOpen(true);
  }, [enabled]);

  const dismiss = () => {
    setOpen(false);
    try {
      localStorage.setItem(DISMISS_KEY, "1");
    } catch (_) {
      /* ignore */
    }
  };

  const enable = async () => {
    setBusy(true);
    setErr("");
    try {
      await registerWebPushOnDevice();
      setOpen(false);
    } catch (e) {
      setErr(e?.message || "Não foi possível ativar as notificações.");
    } finally {
      setBusy(false);
    }
  };

  if (!open) return null;

  return (
    <Collapse in={open}>
      <Alert
        severity="warning"
        sx={{ borderRadius: 0 }}
        action={
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Button
              color="inherit"
              size="small"
              disabled={busy}
              onClick={enable}
              sx={{ textTransform: "none", fontWeight: 700 }}
            >
              Ativar
            </Button>
            <Button color="inherit" size="small" onClick={dismiss} sx={{ textTransform: "none" }}>
              Agora não
            </Button>
          </Stack>
        }
      >
        <Typography variant="body2" fontWeight={700}>
          Ative notificações para receber ligações
        </Typography>
        <Typography variant="caption" display="block">
          Quando o app estiver em segundo plano, avisamos você e ligamos para o seu celular se
          necessário.
        </Typography>
        {err ? (
          <Typography variant="caption" color="error" display="block" sx={{ mt: 0.5 }}>
            {err}
          </Typography>
        ) : null}
      </Alert>
    </Collapse>
  );
}
